import type * as Graphql from "@hireroo/graphql/client/urql";

export const generateTimestampFromDate = (date: Date): Graphql.TimestampInput => {
  const seconds = Math.floor(date.getTime() / 1000);
  return {
    seconds: seconds,
    nanos: 0,
  };
};
